module.exports = __webpack_public_path__ + "static/media/backgroundRegions.d34480d2.png";